import React from "react";
import { BlockWrapper } from '../Preview';
import { generateCss, generateEvent } from "../../functions/sortableFunctions";
import Map from './loop';

const Field = ({ block, ...props }: any) => {
    const timerRef = React.useRef();
    return (
        <React.Fragment>
            {
                React.createElement(
                    block.type,
                    {
                        id: block?.id,
                        style: {
                            fontFamily: block?.style?.fontFamily
                        },
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            }
                        }),
                        ...block.data,
                        for: block?.data?.for,

                        checked: (block?.data?.type === 'checkbox' || block?.data?.type === 'radio') ? eval(block.data.checked.value) : null,
                        value: block?.data?.value ?
                            typeof block.data.value == 'object' ?
                                block.data.value.custom ?
                                    eval(block.data.value.value) :
                                    props.singleData?.[block.data.value.fieldName] :
                                (block.data?.type && (block?.data?.type === 'checkbox' || block?.data?.type === 'radio')) ?
                                    block?.data?.value :
                                    null :
                            null,
                        min: block?.data?.min ? typeof block.data.min == 'object' ? eval(block.data.min.value) : block.data.min : null,
                        max: block?.data?.max ? typeof block.data.max == 'object' ? eval(block.data.max.value) : block.data.max : null,

                        onChange: block.events?.onChange ? async (e) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onChange",
                                timerRef: timerRef
                            });
                        }
                            :
                            null
                    },
                    block.children ?
                        block.children?.[0]?.type == "Map" ?
                            Map({ ...props, block: block.children[0] })
                            :
                            block.children?.map((value: any, index: any) => {
                                return <BlockWrapper {...props} block={value} key={index} />;
                            })
                        :
                        null
                )
            }
        </React.Fragment>
    )
}
export default Field;